function FontModal() {

}

FontModal.playerNameFont = [
    "Athletic Block", "City Block", "Condensed Block", "Full Block", "Jersey Block", "PLAIN", "Square", "Swiss Condensed", "Tiffany", "Times", "Velo Block"
];

FontModal.events = {
    isInit: true,

    init: function() {
        var self = this;

        if (self.isInit) {
            $("#richardson-font-modal").on("click", ".font-item", self.onSelectFont);
            self.isInit = false;
        }
    },

    onSelectFont: function() {
        var code = $(this).data('application-code');
        var font_id = $(this).data('font-id');
        var applicationSettings = ub.funcs.getApplicationSettings(code);
        var fontObject = _.find(ub.data.fonts, {id: font_id.toFixed()});

        if (font_id.toString() === applicationSettings.font_obj.id) {
            return;
        }

        if (typeof fontObject !== "undefined") {
            if (TextShapeCore.utilities.isTextShape(applicationSettings.code)) {
                if (applicationSettings.text_shape_type === "arc") {
                    TextShapeCore.customControllers.changeTextArcFontStyle(applicationSettings.code, false, font_id);
                } else {
                    TextShapeCore.canvas.changeFont(applicationSettings.code, false, font_id);
                }
            } else {
                ApplicationCore.controllers.changeTextApplicationFontStyle(applicationSettings.code, false, font_id);
            }
        } else {
            ub.utilities.warn("Cannot find font with the ID of " + font_id);
        }

        UIkit.modal("#richardson-font-modal").hide();
    
    }
}

FontModal.funcs = {
    loadFontModal: function(text, application) {
        var fontObject = application.font_obj;
        var applicationType = typeof application.textLayoutType !== "undefined" ? application.textLayoutType : application.application_type;

        var fontData = [];
        var sampleSize = "1.5rem"

        _.each(ub.data.fonts, function(font) {
            if (_.contains(ub.data.scriptFonts, font.alias)) {
                text = ub.utilities.titleCase(text);
            } else {
                text = text.toUpperCase();
            }

            if (applicationType === "front_number" || applicationType === "back_number" || applicationType === "sleeve_number" || applicationType === "shoulder_number") {
                if (_.contains(NumbersPanel.fontExcept, font.name)) {
                    return;
                }
            }

            if (applicationType === "team_name") {
                if (font.name !== undefined) {
                    switch (font.name.toLowerCase()) {
                        case "velo block bsb":
                            sampleSize = "1rem";
                            break;

                        case "square bsb":
                            sampleSize = "1rem";
                            break;

                        case "plain bsb":
                            sampleSize = "1em";
                            break;
                    }
                }
            }

            if (applicationType === "player_name") {
                if (!_.contains(FontModal.playerNameFont, font.alias)){
                    return;
                }
            }

            fontData.push({
                id: font.id,
                name: font.name,
                caption: font.caption,
                sampleText: text,
                sampleSize: sampleSize
            });
        });

        var data = {
            code: application.code,
            application_type: applicationType.replace("_", " "),
            fonts: fontData,
        }

        var template = document.getElementById("m-richardson-font").innerHTML;
        var render = Mustache.render(template, data);

        $("#richardson-font-modal .richardson-font-main-container").html("");
        $("#richardson-font-modal .richardson-font-main-container").html(render);

        $("#richardson-font-modal .font-container a.uk-active").parent().removeClass("uk-disabled");
        $("#richardson-font-modal .font-container a.uk-active").removeClass("uk-active");

        $("#richardson-font-modal .font-container a[data-font-id='"+ fontObject.id +"']").parent().addClass("uk-disabled");
        $("#richardson-font-modal .font-container a[data-font-id='"+ fontObject.id +"']").addClass("uk-active");

        FontModal.events.init()

        UIkit.modal("#richardson-font-modal").show();
    }
}
